
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Menu from 'components/Menu'
import MenuItem from 'components/MenuItem'

export default class MainNav extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    openHelp: PropTypes.func
  }

  static contextTypes = {
    permissions: PropTypes.object,
    crossSiteMode: PropTypes.bool
  }

  render() {
    const {className, openHelp} = this.props
    const {permissions} = this.context

    if (!permissions) return null

    return (
      <nav className={classnames('main-nav', className)}>
        {this.renderOverview()}
        {this.renderExplore()}
        <Menu title='Configure'>
          <MenuItem to='/settings' icon='settings'>Settings</MenuItem>
          {/* {permissions.show.includes('@features/billing') && <MenuItem to='/billing' icon='billing'>Billing</MenuItem>} */}
          {/* {permissions.show.includes('@features/account') && <MenuItem to='/account' icon='account'>Account</MenuItem>} */}
          <MenuItem onClick={openHelp} icon='question'>Help</MenuItem>
        </Menu>
      </nav>
    )
  }

  renderOverview() {
    const {crossSiteMode} = this.context

    if (crossSiteMode) {
      return (
        <Menu title='Overview'>
          <MenuItem to='/cross-site/dashboard' icon='dashboard'>Dashboard</MenuItem>
          <MenuItem to='/cross-site/traffic' icon='traffic'>Traffic</MenuItem>
          <MenuItem to='/cross-site/conversions' icon='orders'>Conversions</MenuItem>
          {/* <MenuItem to='/cross-site/costs-overview' icon='costs'>Costs</MenuItem> */}
        </Menu>
      )
    }

    return (
      <Menu title='Overview'>
        <MenuItem to='/dashboard' icon='dashboard'>Dashboard</MenuItem>
        {/* <MenuItem to='/traffic' icon='traffic'>Traffic</MenuItem> */}
        {/* <MenuItem to='/conversion' icon='conversion'>Funnel</MenuItem> */}
        {/* <MenuItem to='/conversions' icon='orders'>Conversions</MenuItem> */}
        <MenuItem to='/data-collection' icon='integrations'>Data Collection</MenuItem>
        {/* <MenuItem to='/costs-overview' icon='costs'>Costs</MenuItem> */}
      </Menu>
    )
  }

  renderExplore() {
    const {crossSiteMode} = this.context

    if (crossSiteMode) {
      return (
        <Menu title='Explore'>
          <MenuItem to='/cross-site/analytics' icon='analytics'>Analytics</MenuItem>
        </Menu>
      )
    } else {
      return (
        <Menu title='Explore'>
          <MenuItem to='/analytics' icon='analytics'>Analytics</MenuItem>
          <MenuItem to='/attribution-explorer' icon='orders-explorer'>Attribution</MenuItem>
          <MenuItem to='/aggreated-attribution-explorer' icon='orders-explorer'>Aggr. Attribution</MenuItem>
        </Menu>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/MainNav/index.js